import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Spinner } from "../../shared/svgIcon";
import { consumerDeletion } from "../../lib/api";
import { toast } from "sonner";
export default function DeleteForm(props) {
  const {  id } = useParams();
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);

  let navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const deleteConsumer = async (id) => {
    try {
      console.log("sign", id);
      setError("");
      setLoading(true);
      const res = await consumerDeletion(id);
      console.log(res);

      if (res?.isSuccess) {
        navigate('/accountdeleted')

      } else {
        setError(res?.data?.message || "try again");
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "rr");
      setLoading(false);
    }
  };

  const onSubmit = (data) => {
    console.log("payload", data,id);

    if(data.delete === 'DELETE'){
      deleteConsumer(id);
    }else{
      toast("Deletion Failed.")
    }
  };



  return (
    <div className="bg-primary text-white   relative  flex flex-col min-dh-screen">
      <div className="z-20 relative px-6 py-4  sm:w-3/5 ">
        <div className="flex w-full">
          <div className="flex-1 mt-4 mx-auto">
            <img src="../../../images/Logo.svg" alt="logo" className="mb-4" />
          </div>
        </div>

        <div className="text-left font-semibold mb-2">
          <>
            <span className="text-xl capitalize">
              Delete Account
            </span>{" "}
            <br />
          </>
        </div>
      </div>
      <div className="overflow-hidden bg-white w-full  rounded-t-xl flex flex-col sm:w-3/5 mx-auto text-black flex-1">
        <div className="flex flex-col  pt-4 mx-2 flex-1">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-2">
              <div className="w-full">
                <div className="flex flex-col px-2 text-lg font-semibold mb-2" >
                <p >Delete your account will remove all of your information from our database.</p>
                <p>This cannot be undone.</p>
                </div>
                 
                <label
                  htmlFor="delete"
                  className="text-gray-400 text-sm font-semibold  pl-2 mb-3"
                >
                   To confirm this, type "DELETE"
                </label>
                <div className="flex">
                  <input
                    {...register("delete", {
                      required: true,
                    })}
                    placeholder="DELETE"
                    id="delete"
                    name="delete"
                    type="text"
                    autoComplete="off"
                    autoCorrect="off"
                    className="w-full bg-gray-200  flex  rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 placeholder:italic"
                  />{" "}
                </div>

                {errors.delete && (
                  <p className="py-2 text-xs text-red-500">{"required"}</p>
                )}
              </div>
             
            </div>
            <div className="flex justify-end w-full gap-2 ">
              <button
                className="bg-red-500 rounded-[100px] text-center flex shadow  mt-4   w-3/4 mx-auto"
                type="submit"
              >
                <div className="text-white  font-semibold font-['SF Pro Display']  flex justify-center items-center px-4 py-3 w-full">
                  {isLoading && (
                    <Spinner className="mr-2 h-4 w-4 animate-spin" />
                  )}{" "}
                  Delete Account
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
